import React, { useEffect } from 'react'
import StartCase from '../components/StartCase'
import { useParams } from '@caudena/core/Router/router'
import { useAppLayoutSetter } from '@caudena/core/state'

export const PageStartCase = () => {
  const { id } = useParams<{ id: string }>()
  const setLayout = useAppLayoutSetter()
  useEffect(() => {
    setLayout({ title: 'Open case', fixedHeader: true })
  }, [])
  return <StartCase id={id} />
}
